import { StrictDict } from '../../../utils';

import app from './app';
import video from './video';

export default StrictDict({
  app,
  video,
});
